export enum enumCbpAssignedNumberStatus {
  REQUESTED,
  SENDING,
  SENT,
  COMPLETED,
  REJECTED,
}
